import React, { useEffect, useRef, useState } from 'react'
import AllChatbot from '../../All_Chatbot/AllChatbot';
import { formatParagraph, StingKillInfoOverview, StingKillInfoOverviewForUpdate } from '../../../Utils/LetterCase';
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import { HomeOwner } from "../../../Utils/Constant";
import SubmitUpdate from "../Updates/SubmitUpdate";
import FactCheck from "../Updates/FactCheck";
import TextEditor from '../../../Utils/TextEditor';
import { useDispatch } from 'react-redux';
import { fetchCommunityByCommunityId, updateCommunityApi } from '../../../Services/Community/CommunityAPI/communityApi';
import { useParams } from 'react-router-dom';
import { decryptId } from '../../../Utils/Crypto';
import { toast } from "react-toastify";

const Overview = ({ communityName, comData, comOver }) => {
    const dispatch = useDispatch();
    const userType = localStorage.getItem("user_type");
    const userId = localStorage.getItem("user_id");
    const contentRef = useRef(null);
    const { encryptedId } = useParams();
    const id = decryptId(encryptedId);
    const [contentEditable, setContentEditable] = useState(false);
    const [overviewUpdate, setOverviewUpdate] = useState();

    useEffect(() => {
        setOverviewUpdate(StingKillInfoOverviewForUpdate(comOver)?.props?.dangerouslySetInnerHTML?.__html);
    }, [comOver])

    const handleOverviewUpdate = async (overviewupdate) => {
        try {
            const formDataToSubmit = new FormData();
            formDataToSubmit.append("community_overview", overviewupdate);

            await dispatch(
                updateCommunityApi({
                    communityId: id,
                    formData: formDataToSubmit,
                })
            );

            toast.success("Community Overview Updated Successfully");
            dispatch(fetchCommunityByCommunityId(id));
        } catch (error) {
            toast.error("Failed to update Community Overview");
            console.error("Update Error:", error);
        } finally {
            setContentEditable(false);
        }
    };

    return (
        <div className="tab-content">
            <div className="d-flex justify-content-between align-items-center heading-buttons-block">
                <div className="tab-titles">Community Overview</div>
                {userId != null && comData?.owned_by === userId ? (
                    contentEditable ? (
                        <div className="update-btn-action-group">
                            <button
                                className="btn-update-done"
                                onClick={() =>
                                    handleOverviewUpdate(
                                        formatParagraph(overviewUpdate)
                                    )
                                }
                            >
                                <DoneIcon />
                            </button>{" "}
                            <button
                                className="btn-update-close"
                                onClick={() => setContentEditable(false)}
                            >
                                <CloseIcon style={{ color: "" }} />
                            </button>
                        </div>
                    ) : (
                        <button
                            className="btn-outline-orange"
                            onClick={() => {
                                setContentEditable(true);
                                setTimeout(() => {
                                    if (contentRef.current) {
                                        contentRef.current.focus();
                                    }
                                }, 0);
                            }}
                        >
                            Update Overview
                        </button>
                    )
                ) : userId == null || userType === HomeOwner ? (
                    <div className="tab-btns-block d-flex">
                        <SubmitUpdate comData={comData} />
                        <FactCheck />
                    </div>
                ) : (
                    <></>
                )}
            </div>
            {contentEditable ? (
                <TextEditor
                    content={overviewUpdate}
                    setContent={setOverviewUpdate}
                />
            ) : (
                <p
                >
                    {comOver ? StingKillInfoOverview(comOver) : null}
                </p>
            )}
            <AllChatbot communitName={communityName} />
        </div>
    )
}

export default Overview